export const USER_LOAD_DATA = 'USER_LOAD_DATA';

export const ASYNC_USER_LOAD_DATA = 'ASYNC_USER_LOAD_DATA';
export const ASYNC_USER_LOGIN = 'ASYNC_USER_LOGIN';
export const ASYNC_USER_LOGOUT = 'ASYNC_USER_LOGOUT';
export const ASYNC_CREATE_USER = 'ASYNC_CREATE_USER';
export const ASYNC_EDIT_USER = 'ASYNC_EDIT_USER';
export const ASYNC_DELETE_USER = 'ASYNC_DELETE_USER';
export const ASYNC_RESTORE_USER = 'ASYNC_RESTORE_USER';
